import React from "react";

const SUGGESTION_CARDS = [
  { icon: "🔍", text: "Which dataset should I use to analyse inventory levels by warehouse?" },
  { icon: "📊", text: "How many active data assets are under the Supply Chain domain?" },
  { icon: "⚠️", text: "Which assets have the worst average DQ score this month?" },
  { icon: "🗂️", text: "Show all sub-domains under Operations parent domain." },
];


export default function WelcomeScreen({ onSuggestionClick }) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center gap-6 px-6">
      {/* Gradient Blob Icon */}
      <div
        className="w-20 h-20 rounded-2xl shadow-lg"
        style={{
          background: "linear-gradient(135deg, #60a5fa 0%, #818cf8 50%, #f472b6 100%)",
        }}
      />

      {/* Heading & Subtitle */}
      <div>
        <h2 className="text-3xl font-bold text-gray-900 mb-3">Welcome to Pulse AI</h2>
        <p className="text-gray-500 text-sm max-w-md leading-relaxed">
          Your intelligent assistant for data asset discovery, quality insights, and domain
          exploration. Feel the heartbeat of your data ecosystem!
        </p>
      </div>

      {/* Suggestion Cards */}
      <div className="grid grid-cols-2 gap-3 w-full max-w-2xl">
        {SUGGESTION_CARDS.map((card, i) => (
          <button
            key={i}
            onClick={() => onSuggestionClick?.(card.text)}
            className="flex items-start gap-3 p-4 bg-white border border-gray-200 rounded-xl hover:border-indigo-300 hover:bg-indigo-50 text-left transition-colors shadow-sm"
          >
            <span className="text-lg shrink-0 mt-0.5">{card.icon}</span>
            <span className="text-sm text-gray-700 leading-snug">{card.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}